function convert(obj) {
  return Object
    .entries(obj)
    .map(entry => {
      const [value, label] = entry;
      return {
        value,
        label,
        active: true
      };
    });
}

module.exports = convert;
